import {
  ABOUT,
  CONTACT,
  ENGLISH,
  HERO_SUBTITLE,
  HERO_TITLE,
  HINDI,
  HOME,
  LANGUAGE,
  NAV_NEWS,
  PARTNER,
  STATS_CENTRE,
  STATS_CUSTOMER,
  STATS_FARMERS,
  STATS_LOCATION,
  STATS_PARTNERS,
  TEAM,
  TITLE,
  AS_SEEN_IN,
  NEWS_EYEBROW,
  NEWS_TITLE,
  NEWS_SUBTITLE,
  READ_ARTICLE,
  STATS_PRODUCTS,
  INPUT,
  INPUT_DESCRIPTION,
  INPUT_FEATURE_1,
  INPUT_FEATURE_2,
  INPUT_FEATURE_4,
  INPUT_FEATURE_5,
  INPUT_FEATURE_3,
  OUTPUT,
  OUTPUT_DESCRIPTION,
  OUTPUT_FEATURE_1,
  OUTPUT_FEATURE_2,
  OUTPUT_FEATURE_3,
  CROP_ADVISORY,
  CROP_ADVISORY_DESCRIPTION,
  CROP_ADVISORY_FEATURE_1,
  CROP_ADVISORY_FEATURE_2,
  CROP_ADVISORY_FEATURE_3,
  CROP_ADVISORY_FEATURE_4,
  CROP_ADVISORY_FEATURE_5,
  FINANCIAL,
  FINANCIAL_DESCRIPTION,
  FINANCIAL_FEATURE_1,
  FINANCIAL_FEATURE_2,
  CONTACT_US,
  ADDRESS_1,
  ADDRESS_2,
  ADDRESS_3,
  PHONE,
  EMAIL,
  FOUNDERS,
  HERO_EYEBROW,
  HERO_TITLE_EMPHASIS,
  NAV_CTA,
} from "../../navbar/menu";
import {
  TEAM_LABEL,
  TEAM_MEMBER_1_DESCRIPTION,
  TEAM_MEMBER_1_NAME,
  TEAM_MEMBER_1_ROLE,
  TEAM_MEMBER_2_DESCRIPTION,
  TEAM_MEMBER_2_ROLE,
  TEAM_MEMBER_3_DESCRIPTION,
  TEAM_MEMBER_3_NAME,
  TEAM_MEMBER_3_ROLE,
  TEAM_MEMBER_2_NAME,
  TEAM_MEMBER_4_NAME,
  TEAM_MEMBER_4_ROLE,
  TEAM_MEMBER_4_DESCRIPTION,
  TEAM_MEMBER_5_NAME,
  TEAM_MEMBER_5_ROLE,
  TEAM_MEMBER_5_DESCRIPTION,
  TEAM_MEMBER_6_NAME,
  TEAM_MEMBER_6_DESCRIPTION,
  TEAM_MEMBER_6_ROLE,
} from "../team";
import {
  SERVICES_SUBTITLE,
  SERVICES_TITLE,
  SERVICES_PANEL_LABEL,
  SERVICES_PANEL_HEADING,
  SERVICES_INTRO_PARAGRAPH,
  SERVICES_CARD_BTN,
  INPUT_BADGE,
  INPUT_CARD_DESC,
  OUTPUT_BADGE,
  OUTPUT_CARD_DESC,
  ADVISORY_CARD_DESC,
  FINANCIAL_CARD_DESC,
} from "../services";
import { TESTIMONIAL_DESCRIPTION, TESTIMONIAL_LABEL } from "../testimonial";
import { FOOTER_TAGLINE, FOOTER_QUICK_LINKS, FOOTER_LEGAL } from "../footer";
import { PARTNER_DESCRIPTION, PARTNER_EYEBROW, PARTNER_LABEL } from "../partner";
import {
  CONTACT_EYEBROW,
  CONTACT_LABEL,
  QUESTION_FORM_SUBTITLE,
  QUESTION_FORM_TITLE,
} from "../contact";
import {
  OUR_BRANDS_LABEL,
  BRANDS_HEADING,
  BRANDS_HEADING_EMPHASIS,
  BRANDS_SUBTITLE,
  BRAND_NUKRISHI_KICKER,
  BRAND_NUKRISHI_NAME,
  BRAND_NUKRISHI_DESC,
  BRAND_NUKRISHI_TAG_1,
  BRAND_NUKRISHI_TAG_2,
  BRAND_NUKRISHI_TAG_3,
  BRAND_AMERICANBULLS_KICKER,
  BRAND_AMERICANBULLS_NAME,
  BRAND_AMERICANBULLS_DESC,
  BRAND_AMERICANBULLS_TAG_1,
  BRAND_AMERICANBULLS_TAG_2,
  BRAND_VISIT_CTA,
} from "../brands";
import {
  ABOUT_EYEBROW,
  ABOUT_TITLE,
  ABOUT_TITLE_EMPHASIS,
  ABOUT_SUBTITLE,
  ABOUT_STORY_LABEL,
  ABOUT_STORY_HEADING,
  ABOUT_STORY_PARA_1,
  ABOUT_STORY_PARA_2,
  ABOUT_STORY_PARA_3,
  ABOUT_STATS_LABEL,
  ABOUT_STATS_HEADING,
  ABOUT_FOUNDERS_LABEL,
  ABOUT_FOUNDERS_HEADING,
  ABOUT_CTA_HEADING,
} from "../about";

export const enTranslation = {
  [TITLE]: "Freshokartz",
  [LANGUAGE]: "Language",
  [ENGLISH]: "English",
  [HINDI]: "Hindi",

  [HOME]: "HOME",
  [ABOUT]: "ABOUT",
  [PARTNER]: "PARTNERS",
  [TEAM]: "TEAM",
  [FOUNDERS]: "FOUNDERS",
  [CONTACT]: "CONTACT",
  [NAV_NEWS]: "NEWS",

  [HERO_EYEBROW]: "Reengineering Indian Agriculture",
  [HERO_TITLE]: "Reinventing Indian agriculture,",
  [HERO_TITLE_EMPHASIS]: "one farm at a time",
  [HERO_SUBTITLE]:
    "We have dedicated ourselves to reengineer the indian agriculture to support our farmers and boost their productivity with our products, agri specialist and education platforms",
  [NAV_CTA]: "Partner With Us",

  [STATS_CENTRE]: "Farm Centres",
  [STATS_FARMERS]: "Connected Farmers",
  [STATS_LOCATION]: "States",
  [STATS_CUSTOMER]: "B2B customers",
  [STATS_PARTNERS]: "Partners",
  [STATS_PRODUCTS]: "Different products",

  [AS_SEEN_IN]: "As Seen In",
  [NEWS_EYEBROW]: "In The News",
  [NEWS_TITLE]: "News Mentions",
  [NEWS_SUBTITLE]: "Check out our mentions in latest news",

  [READ_ARTICLE]: "Read Article",

  [INPUT]: "Input",
  [INPUT_DESCRIPTION]:
    "We offer Seeds, Fertilizers, Pesticides etc. for farmers.",
  [INPUT_FEATURE_1]: "💸 At affordable rates.",
  [INPUT_FEATURE_2]: "🚪 We deliver at your doorstep.",
  [INPUT_FEATURE_3]: "📞 You can place orders over a phone call.",
  [INPUT_FEATURE_4]: "💯 We offer the best quality products.",
  [INPUT_FEATURE_5]: "🛒 We have more than 10000 different types of products.",

  [OUTPUT]: "Output",
  [OUTPUT_DESCRIPTION]: "Farmers can easily sell their Yield to Freshokartz.",
  [OUTPUT_FEATURE_1]: "🚚 Direct Connectivity with the market.",
  [OUTPUT_FEATURE_2]: "⚖️ Transparent weighing and rate at one place.",
  [OUTPUT_FEATURE_3]: "💸 Immediate payment of the agri produce.",

  [CROP_ADVISORY]: "Crop Advisory",
  [CROP_ADVISORY_DESCRIPTION]:
    "Our excellent agri experts are always there for you.",
  [CROP_ADVISORY_FEATURE_1]: "🔬 Soil Testing.",
  [CROP_ADVISORY_FEATURE_2]:
    "👨🏼 Free field and crop inspection by agri experts.",
  [CROP_ADVISORY_FEATURE_3]:
    "❗️ Consultation, Prevention & Cure of Crop Diseases.",
  [CROP_ADVISORY_FEATURE_4]:
    "📕 Free Consultation & Guidance from sowing to reaping by our expert agri advisors.",
  [CROP_ADVISORY_FEATURE_5]: "📣 24X7 Helpline support.",

  [FINANCIAL]: "Financial",
  [FINANCIAL_DESCRIPTION]: "Loaning/ Financing",
  [FINANCIAL_FEATURE_1]: "💸 Credit Facility During Season.",
  [FINANCIAL_FEATURE_2]: "🚜 Agricultural Equipment financing.",

  [CONTACT_US]: "Contact Us",
  [FOOTER_TAGLINE]:
    "Reengineering Indian agriculture — connecting farmers to inputs, markets, and financial services, end to end.",
  [FOOTER_QUICK_LINKS]: "Quick Links",
  [FOOTER_LEGAL]: "Legal",

  [ADDRESS_1]: "3rd floor, B2/425, Roshan Marg,",
  [ADDRESS_2]: "Chitrakoot, Vaishali Nagar, Jaipur,",
  [ADDRESS_3]: "Rajasthan 302021",
  [PHONE]: "Phone:",
  [EMAIL]: "Email:",

  [TEAM_LABEL]: "Our Team",
  [TEAM_MEMBER_1_NAME]: "Rajendra Lora",
  [TEAM_MEMBER_1_ROLE]: "Co-Founder and CEO",
  [TEAM_MEMBER_1_DESCRIPTION]:
    "Ex. Software Engineer, Suvidhaa.com | B. Tech. IIIT Jabalpur",

  [TEAM_MEMBER_2_NAME]: "Chandrakanta Sahu",
  [TEAM_MEMBER_2_ROLE]: "Co-Founder and COO",
  [TEAM_MEMBER_2_DESCRIPTION]: "Head of Operations Netprologic",

  [TEAM_MEMBER_3_NAME]: "Laxman Sharma",
  [TEAM_MEMBER_3_ROLE]: "Chief Technology Officer",
  [TEAM_MEMBER_3_DESCRIPTION]:
    "Ex. Backend Developer, Booking.com | Ex. Full Stack Developer Credit Suisse",

  [TEAM_MEMBER_4_NAME]: "Saksham Sharma",
  [TEAM_MEMBER_4_ROLE]: "Executive Vice President",
  [TEAM_MEMBER_4_DESCRIPTION]: "Founder of 2 successful startups",

  [TEAM_MEMBER_5_NAME]: "Ravi Dhaka",
  [TEAM_MEMBER_5_ROLE]: "AVP Business Development & Operations",
  [TEAM_MEMBER_5_DESCRIPTION]: "Ex. Relationship Manager, HDFC",

  [TEAM_MEMBER_6_NAME]: "Abhishek Sharma",
  [TEAM_MEMBER_6_ROLE]: "AVP Finance",
  [TEAM_MEMBER_6_DESCRIPTION]: "Chartered Accountant",

  [SERVICES_TITLE]: "Our Services",
  [SERVICES_SUBTITLE]: "Helping farmers throughout their Journey",

  [SERVICES_PANEL_LABEL]: "Freshokartz Services",
  [SERVICES_PANEL_HEADING]: "Everything a Farm Needs, End to End",
  [SERVICES_INTRO_PARAGRAPH]:
    "From the seeds you plant to the buyer who pays you — Freshokartz covers every step, through our Agri Input Dukaan and Market Linkage programs.",
  [SERVICES_CARD_BTN]: "Explore More",
  [INPUT_BADGE]: "Agri Input Dukaan",
  [INPUT_CARD_DESC]:
    "Seeds, fertilizers & pesticides delivered through our Village Level Entrepreneur network — even to remote communities.",
  [OUTPUT_BADGE]: "Market Linkage",
  [OUTPUT_CARD_DESC]:
    "Sell your yield directly to buyers like Adani, Cargill & ITC — full traceability, immediate payment.",
  [ADVISORY_CARD_DESC]:
    "Our agri experts are always there for you — soil testing, field inspection, disease prevention.",
  [FINANCIAL_CARD_DESC]:
    "Credit facility during season and agricultural equipment financing, built for farmers.",

  [TESTIMONIAL_LABEL]: "Testimonials",
  [TESTIMONIAL_DESCRIPTION]:
    "We love to hear our customers. See what other farmers say about Freshokartz.",

  [PARTNER_EYEBROW]: "Our Network",
  [PARTNER_LABEL]: "Our Partners",
  [PARTNER_DESCRIPTION]: "We work with the best in the industry.",

  [CONTACT_EYEBROW]: "Get In Touch",
  [CONTACT_LABEL]: "Contact Us",
  [QUESTION_FORM_TITLE]: "Have a Question?",
  [QUESTION_FORM_SUBTITLE]: "Let us know. Our Team will reach out to you.",

  [OUR_BRANDS_LABEL]: "Our Brands",
  [BRANDS_HEADING]: "Two brands built for",
  [BRANDS_HEADING_EMPHASIS]: "every farm",
  [BRANDS_SUBTITLE]:
    "Freshokartz’s flagship platforms bring specialized agri-inputs and machinery directly to farmers, each with its own dedicated home.",

  [BRAND_NUKRISHI_KICKER]: "Agri Inputs",
  [BRAND_NUKRISHI_NAME]: "NuKrishi",
  [BRAND_NUKRISHI_DESC]:
    "A new-age agri-inputs platform delivering high-quality fertilizers, pesticides, and seeds through a dedicated dealer network.",
  [BRAND_NUKRISHI_TAG_1]: "Fertilizers",
  [BRAND_NUKRISHI_TAG_2]: "Pesticides",
  [BRAND_NUKRISHI_TAG_3]: "Seeds",

  [BRAND_AMERICANBULLS_KICKER]: "Machinery & Tools",
  [BRAND_AMERICANBULLS_NAME]: "American Bulls",
  [BRAND_AMERICANBULLS_DESC]:
    "Rugged agri-machinery and tools built for the demands of modern Indian farms — from field prep to harvest.",
  [BRAND_AMERICANBULLS_TAG_1]: "Machinery",
  [BRAND_AMERICANBULLS_TAG_2]: "Tools",

  [BRAND_VISIT_CTA]: "Visit Website",

  [ABOUT_EYEBROW]: "About Freshokartz",
  [ABOUT_TITLE]: "Reinventing Indian agriculture,",
  [ABOUT_TITLE_EMPHASIS]: "from seed to market",
  [ABOUT_SUBTITLE]:
    "We’re building the operating system for Indian agriculture — connecting farmers to the inputs, expertise, and buyers they need, so productivity and income grow together.",
  [ABOUT_STORY_LABEL]: "Our Story",
  [ABOUT_STORY_HEADING]: "Why we exist",
  [ABOUT_STORY_PARA_1]:
    "Freshokartz started with a simple observation: Indian farmers were navigating agriculture’s biggest supply chain almost entirely alone — sourcing inputs, diagnosing crop problems, and finding fair buyers, each a separate struggle with no one connecting the dots.",
  [ABOUT_STORY_PARA_2]:
    "So we built the connection. Today Freshokartz brings agri inputs, expert crop advisory, output market access, and financing together under one roof — reaching over 200,000 farmers across 5 states through 40 farm centres and a growing network of partners.",
  [ABOUT_STORY_PARA_3]:
    "We’re still early. Every farm centre we open and every farmer we onboard is a step toward an agriculture sector that works for the people who feed it.",
  [ABOUT_STATS_LABEL]: "By The Numbers",
  [ABOUT_STATS_HEADING]: "Where we stand today",
  [ABOUT_FOUNDERS_LABEL]: "Leadership",
  [ABOUT_FOUNDERS_HEADING]: "Meet the founders",
  [ABOUT_CTA_HEADING]: "Want to build the future of farming with us?",
};  ;
